import AppIcon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const TestingControlsPanel = ({ testEmail, onTestEmailChange, onSendTest, compatibilityStatus }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'excellent':
        return 'text-green-600';
      case 'good':
        return 'text-blue-600';
      case 'fair':
        return 'text-yellow-600';
      default:
        return 'text-red-600';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'excellent':
        return 'CheckCircle2';
      case 'good':
        return 'CheckCircle';
      case 'fair':
        return 'AlertCircle';
      default:
        return 'XCircle';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'excellent':
        return 'ممتاز';
      case 'good':
        return 'جيد';
      case 'fair':
        return 'مقبول';
      default:
        return 'ضعيف';
    }
  };

  return (
    <div className="space-y-6">
      {/* Send Test Email Card */}
      <div className="bg-card rounded-lg border border-border p-6">
        <div className="flex items-center gap-2 mb-4">
          <AppIcon name="Send" size={20} className="text-primary" />
          <h3 className="font-semibold text-foreground">إرسال إيميل تجريبي</h3>
        </div>

        <div className="space-y-4">
          <Input
            type="email"
            label="البريد الإلكتروني"
            placeholder="test@example.com"
            value={testEmail}
            onChange={(e) => onTestEmailChange(e?.target?.value)}
          />

          <Button
            onClick={onSendTest}
            iconName="Send"
            fullWidth
            className="bg-primary hover:bg-primary/90"
          >
            إرسال الآن
          </Button>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
            <div className="flex items-start gap-2">
              <AppIcon name="Info" size={16} className="text-blue-600 mt-0.5" />
              <p className="text-xs text-blue-900">
                سيتم إرسال إيميل تجريبي بالبيانات النموذجية للمعاينة والاختبار فقط
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Email Client Compatibility */}
      <div className="bg-card rounded-lg border border-border p-6">
        <div className="flex items-center gap-2 mb-4">
          <AppIcon name="Shield" size={20} className="text-primary" />
          <h3 className="font-semibold text-foreground">التوافق مع عملاء البريد</h3>
        </div>

        <div className="space-y-3">
          {compatibilityStatus?.map((item, index) => (
            <div key={index} className="flex items-center justify-between py-2 border-b border-border last:border-0">
              <div className="flex items-center gap-2">
                <AppIcon
                  name={getStatusIcon(item?.status)}
                  size={16}
                  className={getStatusColor(item?.status)}
                />
                <span className="text-sm text-foreground">{item?.client}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className={`text-xs font-medium ${getStatusColor(item?.status)}`}>
                  {getStatusLabel(item?.status)}
                </span>
                {item?.arabicSupport && (
                  <div className="flex items-center gap-1 px-2 py-0.5 bg-green-100 rounded text-xs text-green-700">
                    <AppIcon name="Check" size={12} />
                    <span>عربي</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Accessibility Check */}
      <div className="bg-card rounded-lg border border-border p-6">
        <div className="flex items-center gap-2 mb-4">
          <AppIcon name="Accessibility" size={20} className="text-primary" />
          <h3 className="font-semibold text-foreground">فحص إمكانية الوصول</h3>
        </div>

        <div className="space-y-2">
          <div className="flex items-center justify-between py-2">
            <span className="text-sm text-foreground">دعم RTL</span>
            <div className="flex items-center gap-1 text-green-600">
              <AppIcon name="CheckCircle2" size={16} />
              <span className="text-xs font-medium">نشط</span>
            </div>
          </div>
          <div className="flex items-center justify-between py-2">
            <span className="text-sm text-foreground">خط IBM Arabic</span>
            <div className="flex items-center gap-1 text-green-600">
              <AppIcon name="CheckCircle2" size={16} />
              <span className="text-xs font-medium">مفعّل</span>
            </div>
          </div>
          <div className="flex items-center justify-between py-2">
            <span className="text-sm text-foreground">صحة الروابط</span>
            <div className="flex items-center gap-1 text-green-600">
              <AppIcon name="CheckCircle2" size={16} />
              <span className="text-xs font-medium">صحيح</span>
            </div>
          </div>
          <div className="flex items-center justify-between py-2">
            <span className="text-sm text-foreground">تحسين الصور</span>
            <div className="flex items-center gap-1 text-green-600">
              <AppIcon name="CheckCircle2" size={16} />
              <span className="text-xs font-medium">محسّن</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestingControlsPanel;